import React, { useState } from 'react'
import { Button, Card, Divider, Popconfirm, Table, Tag ,Tooltip } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import ProductFeatureForm from './ProductFeatureForm'
import {
  createProductFeature,
  deleteProductFeature,
  fetchProductFeatureList,
  updateProductFeature
} from '../../modules/productFeature'
import _ from 'lodash'

const ProductFeature = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})

  const { productFeatureList ,isLoading } = useSelector(
    (state) => ({
      productFeatureList: state.productFeature.productFeatureList,
      isLoading: state.productFeature.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchProductFeatureList())
    }

    fetch()
  }, [])

  const columns = [
    {
      title: 'No',
      key: 'no',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'Badge',
      dataIndex: 'badge',
      key: 'badge',
      render: (text) => (
        <div>
          <img
            src={text}
            width={64}
            height={64}
            style={{ marginRight: 10, objectFit: 'cover' }}
            alt="Badge"
          />
        </div>
      )
    },
    {
      title: 'Detail',
      key: 'detail',
      dataIndex: 'detail'
    },
    {
      title: 'Description',
      key: 'description',
      dataIndex: 'description',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
          }
        }
      },
      render: (description) => (
        <Tooltip title={description}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{description}</div>
        </Tooltip>
      )
    },
    {
      title: 'Status',
      key: 'enable',
      dataIndex: 'enable',
      render: (text) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormData({})
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateProductFeature(data))
    } else {
      await dispatch(createProductFeature(data))
    }

    await dispatch(fetchProductFeatureList())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteProductFeature(id))
    await dispatch(fetchProductFeatureList())
  }

  const refetchData = async () => {}

  // async function onShowSizeChange(current, pageSize) {
  //   options.size = pageSize
  //   setOptions(options)
  // }
  //
  // async function onChange(page) {
  //   options.page = page - 1
  //   setOptions(options)
  // }
  //
  // const reset = async (e) => {
  //   e.preventDefault()
  //   options.keyword = ''
  //
  //   await form.resetFields()
  // }

  return (
    <Card
      title="Product Feature"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New Product Feature
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      {/* <Form layout="inline" onSubmit={handleSubmit}> */}
      {/*  <Form.Item label="keyword"> */}
      {/*    {form.getFieldDecorator('keyword')(<Input placeholder="บาร์โค้ด,ชื่อสินค้า,ยี่ห้อสินค้า"/>)} */}
      {/*  </Form.Item> */}
      {/*  <Form.Item> */}
      {/*    <Button type="primary" htmlType="submit"> */}
      {/*      ค้นหา */}
      {/*    </Button> */}
      {/*  </Form.Item> */}
      {/*  <Form.Item> */}
      {/*    <Button onClick={(e) => reset(e)}> */}
      {/*      รีเซ็ต */}
      {/*    </Button> */}
      {/*  </Form.Item> */}
      {/* </Form> */}
      <br />
      <Table
        bordered
        loading={isLoading}
        rowKey={(record) => {
          return record.id
        }}
        dataSource={productFeatureList}
        columns={columns}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
      />
      <ProductFeatureForm
        visible={visible}
        formData={formData}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default ProductFeature
